import { useState, useContext, useCallback } from "react";
import { GlobalContext } from "../../Context/GlobalContext";

const usePayout = () => {
  const { api, userID } = useContext(GlobalContext);

  const [loading, setLoading] = useState(false);
  const [payouts, setPayouts] = useState([]);
  const [wallet, setWallet] = useState({});
  const [bankInfo, setBankInfo] = useState([]);
  const [ledger, setLedger] = useState([]);

  const postRequest = useCallback(
    async (endpoint, body) => {
      const response = await api.post(endpoint, body);
      return response?.data;
    },
    [api]
  );

  // Get Payout Report
  const getPayoutReport = async (startDate, endDate) => {
    if (!startDate || !endDate) return;

    try {
      setLoading(true);

      const data = await postRequest(
        "/Transactions/getAllPayouts",
        {
          userid: userID,
          fromDate: startDate,
          toDate: endDate,
        }
      );

      if (data?.responseCode === "00") {
        setPayouts(data?.response || []);
      } else {
        setPayouts([]);
      }

      return data;
    } catch (error) {
      console.error(
        "Payout Report Error:",
        error?.response?.data || error
      );

      setPayouts([]);
      return null;
    } finally {
      setLoading(false);
    }
  };

  const getWalletBalance = async () => {
    try {
      const data = await postRequest(
        "/Transactions/getwalletBalanceV1",
        {
          userid: userID,
        }
      );

      if (data?.responseCode === "00") {
        setWallet(data?.response || {});
      } else {
        setWallet({});
      }

      return data;
    } catch (error) {
      console.error(
        "Wallet Error:",
        error?.response?.data || error
      );

      setWallet({});
      return null;
    }
  };

  // Settlement
  const settlementProcess = async (amount) => {
    try {
      setLoading(true);

      return await postRequest(
        "/Transactions/settlementProccess",
        {
          userid: userID,
          amount: String(amount),
          mode: "IMPS",
        }
      );
    } catch (error) {
      console.error(
        "Settlement Error:",
        error?.response?.data || error
      );

      return null;
    } finally {
      setLoading(false);
    }
  };

  const getLedger = async (
    userid,
    startDate,
    endDate
  ) => {
    try {
      setLoading(true);

      const data = await postRequest(
        "/Transactions/getAccountLedgerV1",
        {
          userid: userID,
          fromDate: startDate,
          toDate: endDate,
        }
      );

      if (data?.responseCode === "00") {
        setLedger(data?.response || []);
      } else {
        setLedger([]);
      }

      return data;
    } catch (error) {
      console.error(
        error?.response?.data || error
      );

      setLedger([]);
      return null;
    } finally {
      setLoading(false);
    }
  };

  return {
    payouts,
    wallet,
    bankInfo,
    ledger,
    loading,
    getPayoutReport,
    getWalletBalance,
    settlementProcess,
    getLedger,
  };
};

export default usePayout;